import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import Button from "../../components/button";
import HtmlEditor from "../../components/htmlEditor";

const CommentForm = (props) => {
  const formik = useFormik({
    initialValues: {
      message: props.message,
    },
    validationSchema: Yup.object({
      message: Yup.string()
        .min(3, "Comment must be of minimum length 3")
        .max(1000, "Comment cannot be greater than 1000 characters")
        .required("Please enter Comment"),
    }),
    onSubmit: (values) => {
      props.onFormSubmit(values.message);
      formik.resetForm();
    },
  });

  return (
    <form className="d-flex align-items-end" onSubmit={formik.handleSubmit}>
      <div className="editor-wrapper editor-wrapper-reply flex-grow-1">
        <HtmlEditor
          name="message"
          value={formik.values.message}
          onChange={(newValue) => formik.setFieldValue("message", newValue)}
          onBlur={() => formik.handleBlur({ target: { name: "message" } })}
        />
        {formik.touched.message && formik.errors.message && (
          <div className="error-message" style={{ color: "red", fontSize: "0.8rem" }}>
            {formik.errors.message}
          </div>
        )}
      </div>

      <div className="ml-3 d-flex align-items-center">
        {props.user !== null && (
          <p className="font-demi-bold mb-0">
            {props.user.firstName}&nbsp;{props.user.lastName}
          </p>
        )}
        <Button
          className="ml-3 ic-btn-transparent-navy-blue"
          style={{ maxWidth: "170px" }}
          title={props.buttonText}
          type="button"
          clickEvent={(e) => {
            formik.submitForm();
          }}
        />
      </div>

      {props.showCancelButton === true && (
        <Button
          className="ml-3"
          style={{ maxWidth: "170px" }}
          title="Cancel"
          type="button"
          clickEvent={props.cancelForm}
        />
      )}
    </form>
  );
};

export default CommentForm;

CommentForm.defaultProps = {
  message: "",
  buttonText: "Publish Comment",
  onFormSubmit: () => {},
  cancelForm: () => {},
  showCancelButton: false,
  user: null,
};

CommentForm.propTypes = {
  message: PropTypes.string,
  buttonText: PropTypes.string,
  onFormSubmit: PropTypes.func,
  cancelForm: PropTypes.func,
  showCancelButton: PropTypes.bool,
  user: PropTypes.object,
};
